import { render } from "./CloseIcon.vue?vue&type=template&id=433c73e4&scoped=true"
const script = {}

import "./CloseIcon.vue?vue&type=style&index=0&id=433c73e4&scoped=true&lang=css"

import exportComponent from "/builds/smartdevops/viccarbe/viccarbe-professional-area/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433c73e4"]])

export default __exports__